import { BreakpointValueProp } from "@store/Framework/Common/Utilities/breakpointValues";
import getArray from "@store/Framework/Common/Utilities/getArray";

const getCleanBreakpointValues = <T extends BreakpointValueProp<any>>(values: T) => {
    const breakpointValues = getArray(values);

    if (!breakpointValues) {
        return breakpointValues;
    }

    let lastValue: any = null;

    return breakpointValues.map(value => {
        const cleanValue = value !== lastValue ? value : null;

        if (cleanValue !== null) {
            lastValue = cleanValue;
        }

        return cleanValue;
    });
};

export default getCleanBreakpointValues;
